import { useState } from 'react';

import { useRequestFortuneMutation } from './models';

import { useProfile } from '@/shared/hooks';

interface Fortune {
  fortuneText: string | null;
  fortuneStatus: 'loading' | 'error' | 'success' | 'default';
  requestFortune: () => void;
}

const useFortune = (): Fortune => {
  const { profile } = useProfile();
  const { mutate, isPending, isError, isSuccess } = useRequestFortuneMutation();
  const [fortuneText, setFortuneText] = useState<string | null>(null);

  const requestFortune = () => {
    if (!profile?.roleKor) return;

    mutate(
      { userRole: profile.roleKor },
      {
        onSuccess: ({ data: { fortuneText } }) => {
          setFortuneText(fortuneText);
        },
      }
    );
  };

  const getFortuneStatus = () => {
    if (isError) return 'error';
    if (isPending) return 'loading';
    if (isSuccess) return 'success';

    return 'default';
  };

  const fortuneStatus = getFortuneStatus();

  return {
    fortuneText,
    fortuneStatus,
    requestFortune,
  };
};

export default useFortune;
